<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <edit-employee-layout :employee-id="empNumber" screen="report-to">
    <div class="orangehrm-horizontal-padding orangehrm-top-padding">
      <oxd-text tag="h6" class="orangehrm-main-title">{{
        $t('pim.report_to')
      }}</oxd-text>
      <oxd-divider />
    </div>
    <employee-supervisors
      :emp-number="empNumber"
      :reporting-methods="reportingMethods"
    ></employee-supervisors>
    <employee-subordinates
      :emp-number="empNumber"
      :reporting-methods="reportingMethods"
    ></employee-subordinates>
    <employee-my-backups v-if="!isEmployee" :emp-number="empNumber">
    </employee-my-backups>
    <employee-backups v-if="!isEmployee" :emp-number="empNumber">
    </employee-backups>
  </edit-employee-layout>
</template>

<script>
import EditEmployeeLayout from '@/orangehrmPimPlugin/components/EditEmployeeLayout';
import EmployeeSupervisors from '@/orangehrmPimPlugin/components/EmployeeSupervisors';
import EmployeeSubordinates from '@/orangehrmPimPlugin/components/EmployeeSubordinates';
import EmployeeBackups from '@/orangehrmPimPlugin/components/backupResponsibilities/EmployeeBackups';
import EmployeeMyBackups from '@/orangehrmPimPlugin/components/myBackup/EmployeeMyBackups';
import UserRoles from '@/orangehrmTrainigPlugin/constants/UserRoles';

const userAuth = window.appGlobal.user;
export default {
  components: {
    'edit-employee-layout': EditEmployeeLayout,
    'employee-supervisors': EmployeeSupervisors,
    'employee-subordinates': EmployeeSubordinates,
    'employee-backups': EmployeeBackups,
    'employee-my-backups': EmployeeMyBackups,
  },
  props: {
    empNumber: {
      type: String,
      required: true,
    },
    reportingMethods: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isViewer() {
      return userAuth.id != parseInt(this.empNumber) &&
        userAuth.roleId != UserRoles.ADMIN.id &&
        !userAuth.subordinates.includes(parseInt(this.empNumber))
        ? true
        : false;
    },
    isEmployee() {
      if (this.isSubordinate) return false;

      return [UserRoles.ESS.id, UserRoles.SUPERVISOR.id].includes(
        userAuth.roleId,
      ) && this.isViewer
        ? true
        : false;
    },
    isSubordinate() {
      if (
        userAuth.roleId === UserRoles.ADMIN.id ||
        userAuth.roleId == UserRoles.SUPERVISOR.id
      )
        return false;

      return userAuth.subordinates.includes(parseInt(this.empNumber));
    },
  },
};
</script>
